 angular.module('evtviewer.imageViewer')
    .controller('imageViewerCtrl',['$scope', function($scope) {}]);

